import React from 'react';
import { motion } from 'framer-motion';
import { ShieldAlert } from 'lucide-react';
export function AgitationSection() {
  return <section className="py-10 md:py-20 px-4 bg-cream" data-id="element-18">
      <div className="max-w-4xl mx-auto" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white p-5 md:p-12 rounded-2xl shadow-lg border border-gold/20 relative" data-id="element-20">
          <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-white p-3 rounded-full shadow-md border border-gold/20" data-id="element-21">
            <ShieldAlert className="w-8 h-8 text-teal-dark" data-id="element-22" />
          </div>

          <div className="space-y-6 mt-4 text-lg text-charcoal/80 leading-relaxed" data-id="element-23">
            <p data-id="element-24">
              Vivimos en un mundo diseñado para mantenernos distraídos, ansiosos
              y desconectados de lo que realmente importa: nuestra eternidad. Te
              prometieron que "la fe mueve montañas", pero a veces sientes que
              apenas tienes fuerza para moverte tú.
            </p>

            <p data-id="element-25">
              Ves cómo el estrés afecta tu salud, cómo las discusiones en casa
              roban la paz de tus hijos y cómo esa "conexión con el Cielo" que
              tanto anhelas se reduce a una oración rápida y cansada antes de
              dormir.
            </p>

            <div className="p-6 bg-red-50 border-l-4 border-red-700 rounded-r-lg mt-8" data-id="element-26">
              <p className="font-bold text-red-900 m-0" data-id="element-27">
                El costo de no resolver esto no es solo el cansancio; es perder
                la brújula espiritual que tu familia necesita que tú sostengas.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}